import React, { useState, useRef, useEffect } from 'react';
import './style.css'; // Ensure this file is correctly linked
import chatboxIcon from './chatbox-icon.svg'; // Assuming you are importing the icon as an asset
import Backgroundimage from '../Animation - 1744083628102.gif'
import SpeakImage from '../thinking_bot.gif'
import ThinkImage from '../Animation - 1744083628102.gif'
import MicListing from '../mic.gif'
import DOTMitraIcon from './dot-mitra 1.png'
import { marked } from "marked";
import DOMPurify from "dompurify";
const Chatbox = () => {
    const sanitizeMessage = (message) => {
        const rawHtml = marked(message); // Convert Markdown to HTML
        return DOMPurify.sanitize(rawHtml); // Sanitize HTML
    };

    const [isActive, setIsActive] = useState(false);
    const [messages, setMessages] = useState([]);
    const [inputText, setInputText] = useState("");
    const inputRef = useRef();

    const [isTyping, setIsTyping] = useState(false);
    const messagesEndRef = useRef(null);

    const [zoomed, setzoomed] = useState(false)
    const [pdfs, setPdfs] = useState([]);

    const [selectedPDF, setSelectedPDF] = useState("All");
    const [selectedPDFName, setSelectedPDFName] = useState("All");

    const [suggestedquestion, setsuggestedquestion] = useState([])
    const [summery, setsummery] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [GotopageNumber, setGotoPageNumber] = useState(false);

    const [Select_Menu, setSelect_Menu] = useState("");
    const [Select_Services, setSelect_Services] = useState("");
    const [Select_Sub_Services, setSelect_Sub_Services] = useState("");
    const [llm_Mode, setLLM_MODE] = useState(false);
    const [llm_active, setllm_active] = useState(false);


    const [Loader, setLoader] = useState(false);
    const [ShowVoiceSetting, setShowVoiceSetting] = useState(false);

    // const BASE_PATH = process.env.REACT_APP_BASE_API_PATH;
    // console.log("BASE_PATH", BASE_PATH)



    const BASE_PATH = "https://stagingeservices.dot.gov.in/dotmitra"

    let iframesrc = BASE_PATH + selectedPDF

    const triggerGotoPage = (pageNumber) => {
        setPageNumber(pageNumber)
        setGotoPageNumber(true);
        setTimeout(() => {
            setGotoPageNumber(false);
        }, 1); // 1 millisecond
    };

    const extractFileName = (path) => {
        return path.replace('/media/pdfs/', '').replace('.pdf', '');
    };

    const handleSendMessage = async (inputText) => {
        if (!inputText || inputText === '') return;

        const userMessage = { name: 'User', message: inputText };
        setMessages((prev) => [...prev, userMessage]);
        setIsTyping(true);
        setLoader(true)
        setsuggestedquestion([])
        try {
            const response = await fetch(`${BASE_PATH}/chat/`, {
                method: 'POST',
                body: JSON.stringify({ With_LLM: llm_active, message: inputText, selectedmode: extractFileName(selectedPDF) }),
                headers: { 'Content-Type': 'application/json' },
            });

            const data = await response.json();

            console.log("response", data)
            let msg = '';
            // const botMessage = { name: 'Sam', message: data.message };
            const pagenumber = extractPageNumber(data.message)
            if (pagenumber) {
                setPageNumber(pagenumber);
                setSelectedPDF(selectedPDF)
            }
            const formattedMessage = data.message
                .replace(/(https?:\/\/[^\s]+)/g, (url) => {
                    return `<a href="${url}?field_questions_value=${inputText}" target="_blank" rel="noopener noreferrer">${url}</a>`;
                })



            if (llm_Mode === true) {
                speak(formattedMessage.replace(/[*\-_~`]+/g, ""))
            }


            const ms = `<p>${data.message.replace(/(https?:\/\/[^\s]+)/g, `<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>`)} </p>`
            const botMessage = { name: 'Sam', message: formattedMessage };

            setMessages((prev) => [...prev, botMessage]);
            setIsTyping(false);
            setLoader(false)
            // simulateTyping(data.message, data.relevant_patterns);
            setsuggestedquestion(data.relevant_patterns)
        } catch (error) {
            setIsTyping(false);
            console.error('Error:', error);
            const errorMessage = { name: 'Sam', message: 'Error connecting to server.' };
            setMessages((prev) => [...prev, errorMessage]);
        }

        setInputText("")
    };

    function extractPageNumber(str) {
        // Regular expression to match "Page: X" where X is a number
        const regex = /Page:\s*(\d+)/;
        // Use regex to match the page number in the string
        const match = str.match(regex);
        // If a match is found, return the page number
        if (match) {
            return parseInt(match[1], 10); // Return the page number as an integer
        }
        // If no match is found, return null or some default value
        return null;
    }



    function renderMessageContent(msg, onPageClick, suggestion) {
        const questionFormatted = msg.replace(/Question:\s*(\d+)/gi, (match, qNum) => {
            return `<span class="bg-warning text-black px-1">Question: ${qNum}</span>`;
        });
        const parts = questionFormatted.split(/(Page:\s*\d+)/gi);

        return parts.map((part, index) => {
            const match = part.match(/Page:\s*(\d+)/i);
            if (match) {
                const pageNum = parseInt(match[1], 10);
                return (
                    <i
                        key={`page-${index}`}
                        className="bg-primary text-white p-1 rounded cursor-pointer mx-1"
                        onClick={() => onPageClick(pageNum)}
                    >
                        P {pageNum}
                    </i>
                );
            }

            const linkified = part.replace(/(https?:\/\/[^\s]+)/g, (url) => {
                return `<a href="${url}?field_questions_value=${suggestion}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            });

            return (
                <span
                    key={index}
                    dangerouslySetInnerHTML={{ __html: sanitizeMessage(linkified) }}
                />
            );
        });
    }

    const handleSendsuggestion = async (suggestion) => {
        const userMessage = { name: 'User', message: suggestion };
        setMessages((prev) => [...prev, userMessage]);
        setIsTyping(true);
        setLoader(true)
        setsuggestedquestion([])
        try {
            const response = await fetch(`${BASE_PATH}/chat/`, {
                method: 'POST',
                body: JSON.stringify({ With_LLM: llm_active, message: suggestion, selectedmode: extractFileName(selectedPDF) }),
                headers: { 'Content-Type': 'application/json' },
            });

            const data = await response.json();
            let msg = '';

            // simulateTyping(data.message, data.relevant_patterns);
            const pagenumber = extractPageNumber(data.message)
            if (pagenumber) {
                console.log("page number", pagenumber)
                setPageNumber(pagenumber);
                setSelectedPDF(selectedPDF)

            }
            const formattedMessage = data.message
                .replace(/(https?:\/\/[^\s]+)/g, (url) => {
                    return `<a href="${url}?field_questions_value=${suggestion}" target="_blank" rel="noopener noreferrer">${url}</a>`;
                })


            if (llm_Mode === true) {
                speak(formattedMessage.replace(/[*\-_~`]+/g, ""))
            }


            const ms = `<p>${data.message.replace(/(https?:\/\/[^\s]+)/g, `<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>`)} </p>`

            const botMessage = { name: 'Sam', message: formattedMessage };

            setMessages((prev) => [...prev, botMessage]);
            setIsTyping(false);
            console.log("response", data)
            setSelectedPDF(selectedPDF)
            // setsummery(data.summary)
            setsuggestedquestion(data.relevant_patterns)
            setLoader(false)
        } catch (error) {
            setIsTyping(false);
            console.error('Error:', error);
            const errorMessage = { name: 'Sam', message: 'Error connecting to server.' };
            setMessages((prev) => [...prev, errorMessage]);
        }

    };


    // const simulateTyping = (text, suggetion) => {
    //     // Check if text is a valid string
    //     if (!text || typeof text !== 'string') {
    //         console.error("Invalid message text.");
    //         return; // Do nothing if the text is invalid
    //     }
    //     let i = 0;
    //     setMessages(prev => {
    //         const lastMessage = prev[prev.length - 1];
    //         // Make sure we don't add undefined values into the state
    //         if (lastMessage && lastMessage.name === "Sam") {
    //             return [
    //                 ...prev.slice(0, -1),
    //                 { name: "Sam", message: lastMessage.message + currentChar }
    //             ];
    //         } else {

    //             return [...prev, { name: "Sam", message: currentChar }];
    //         }
    //     });
    //     const interval = setInterval(() => {
    //         if (i < text.length) {
    //             // Ensure no undefined values are passed
    //             const currentChar = text[i] === undefined ? '' : text[i];
    //             setMessages(prev => {
    //                 const lastMessage = prev[prev.length - 1];
    //                 // Make sure we don't add undefined values into the state
    //                 if (lastMessage && lastMessage.name === "Sam") {
    //                     return [
    //                         ...prev.slice(0, -1),
    //                         { name: "Sam", message: lastMessage.message + currentChar }
    //                     ];
    //                 } else {

    //                     return [...prev, { name: "Sam", message: currentChar }];
    //                 }
    //             });
    //             i++;

    //         } else {
    //             console.log("Finish")
    //             setsuggestedquestion(suggetion)
    //             clearInterval(interval);
    //         }
    //     }, 50); // Typing speed
    // };



    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            handleSendMessage(inputText);
        }
    };

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const fetchPDFFiles = async () => {
        setLoader(true)
        try {
            const response = await fetch(`${BASE_PATH}/pdfs/`, {
                headers: {
                    "Accept": "application/json",
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const text = await response.text(); // Get raw response text
            const data = JSON.parse(text); // Try parsing JSON manually
            // console.log(Array.isArray(data) ? data : [])
            setPdfs(Array.isArray(data) ? data : []);
            setLoader(false)
        } catch (error) {
            console.error("Error fetching PDFs:", error);
            setPdfs([]); // Ensure pdfs is always an array
        }
    };


    useEffect(() => {
        fetchPDFFiles()
        // const files = fetchPDFFiles();
        // setPdfs(files);
    }, [])

    const getdefaultdandomquestion = async (selectedPDF) => {
        if (!selectedPDF) {
            return;
        }
        setLoader(true)
        try {
            const response = await fetch(`${BASE_PATH}/GetRandomQuestion/`, {
                method: 'POST',
                body: JSON.stringify({ selectedmode: extractFileName(selectedPDF) }),
                headers: { 'Content-Type': 'application/json' },
            });

            const data = await response.json();
            // setsummery(data.summary)
            setsuggestedquestion(data.random_questions)
            console.log("data", data)
            setLoader(false)
        } catch (error) {
            // setIsTyping(false);
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        getdefaultdandomquestion(selectedPDF)
    }, [selectedPDF])

    const [isListening, setIsListening] = useState(false);

    const recognitionRef = useRef(null);

    useEffect(() => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new SpeechRecognition();

        recognition.continuous = false;
        recognition.interimResults = false;
        recognition.lang = "en-US";

        recognition.onstart = () => setIsListening(true);
        recognition.onresult = (event) => setInputText(event.results[0][0].transcript);
        recognition.onend = () => setIsListening(false);

        recognitionRef.current = recognition;
    }, []);
    useEffect(() => {
        if (isListening === false) {
            handleSendMessage(inputText)
        }

    }, [isListening])
    const startListening = () => {
        setInputText("");
        recognitionRef.current?.start();
    };
    const stopListening = () => {
        recognitionRef.current?.stop(); // Will trigger onend
    };

    // const speak = () => {
    //     if (!inputText) return;
    //     const utterance = new SpeechSynthesisUtterance(inputText);
    //     utterance.lang = "en-US";
    //     speechSynthesis.speak(utterance);
    // };

    const [voices, setVoices] = useState([]);
    const [selectedVoice, setSelectedVoice] = useState(null);

    // Load available voices
    useEffect(() => {
        const loadVoices = () => {
            const availableVoices = window.speechSynthesis.getVoices();
            setVoices(availableVoices);

            // Set default voice to "Microsoft Madhur Online - Hindi (India)"
            const defaultVoice = availableVoices.find((voice) =>
                voice.name.includes("Swara") && voice.lang === "hi-IN"
            );
            setSelectedVoice(defaultVoice || availableVoices[0]); // Fallback to first voice if not found

        };

        loadVoices();
        window.speechSynthesis.onvoiceschanged = loadVoices; // Refresh when voices change
    }, []);

    const [Speaking, setSpeaking] = useState(false)
    const [speakdata, setspeakdata] = useState("")
    const speak = (text) => {
        if (!text.trim()) return;
        setSpeaking(true)
        const utterance = new SpeechSynthesisUtterance(text);
        // const utterance = new SpeechSynthesisUtterance(text);
        utterance.voice = selectedVoice; // Set selected voice
        utterance.lang = selectedVoice?.lang || "hi-IN";
        // speechSynthesis.speak(utterance);
        utterance.volume = 1;  // Full volume
        utterance.rate = 1;    // Normal speed
        utterance.pitch = 1;   // Normal pitch
        // When speech is completed, start listening again
        utterance.onend = () => {
            console.log("Speech finished, now starting listening...");
            // startListening();
            setSpeaking(false)
        };
        window.speechSynthesis.speak(utterance);
    };
    const stopSpeak = () => {
        setSpeaking(false)
        window.speechSynthesis.cancel();
    };
    // useEffect(() => {
    //     if (!Select_Menu) {
    //         speak(
    //         "Hi there, DoT Mitra is here to help you. Please select one of the options below or type your query. " +
    //         "Option one, Select PDF. Option two, Select a Service. Option three, Type your query."
    //       );
    //     }
    //   }, [Select_Menu]); // Runs when Select_Menu changes
    return (
        <div className={`${isActive? 'chatbox': 'chatbox hide-chat'}`}>
            <div className={`chatbox__support ${isActive ? 'chatbox--active' : ''}`} style={zoomed ? { height: "586px", width: "1200px" } : {}}>
                <div className="chatbox__header">
                    <div className='d-flex justify-content-between align-items-baseline w-100'>
                        <div className='d-flex align-items-center'>
                            <div className="chatbox__image--header">
                                <img
                                    src={DOTMitraIcon}
                                    alt="User Icon"

                                />

                            </div>
                            <div className=''>
                                <div className="chatbox__content--header">
                                    <h4 className="chatbox__heading--header">DoT Mitra</h4>
                                    {/* <p className="chatbox__description--header">Ministry of Communications</p> */}
                                </div>

                            </div>
                        </div>

                        <div className='text-white response-mode-container p-2'>
                            <h10>Response Mode</h10>
                            <div className='d-flex'>
                                <span className='me-1'>default</span>
                                <div className="form-check form-switch corser">
                                    <input onClick={() => (setllm_active(!llm_active))} className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={llm_active} />
                                </div>
                                LLM
                            </div>
                            <i className='bi bi-gear cursor-pointer' title="Voice Settings" style={{ marginLeft: "87%" }} onClick={() => setShowVoiceSetting(!ShowVoiceSetting)}></i>
                        </div>

                    </div>

                    <div className='position-absolute top-0 end-0 me-2 p-1 text-white'>
                        <i onClick={() => setIsActive(!isActive)} className='cursor-pointer fs-6 bi bi-x'></i>
                    </div>

                </div>
                {ShowVoiceSetting &&
                    <select onChange={(e) => setSelectedVoice(voices[e.target.value])}>
                        {voices.map((voice, index) => (
                            <option key={index} value={index}>
                                {voice.name} ({voice.lang})
                            </option>
                        ))}
                    </select>
                }

                <div className='d-flex justify-content-between back__button'>
                    <div className='mt-1'>
                        {Select_Menu === "Select PDF" &&
                            <>
                                {selectedPDF ?
                                    <div className='d-flex  '>
                                        <button onClick={() => { setSelectedPDF(""); setsuggestedquestion([]); setsummery('') }}
                                            className="btn btn-sm btn-primary  bi bi-chevron-left ">
                                        </button>
                                        <button onClick={() => { setSelectedPDF(""); setsuggestedquestion([]); setsummery('') }}
                                            className="btn btn-sm btn-gray-500 d-flex truncate rounded-pill text-start">
                                            <i className="bi-file-earmark-pdf me-2 text-primary "></i>
                                            {selectedPDFName}
                                            {/* <span className="close-button ms-2 text-danger">&times;</span> */}
                                        </button>
                                    </div>
                                    :
                                    <div>
                                        <button onClick={() => setSelect_Menu("")}
                                            className="btn btn-sm btn-primary  bi bi-chevron-left ">
                                        </button>
                                    </div>
                                }
                            </>
                        }
                        {Select_Menu === "Select a Service" && (
                            <>
                                {!Select_Sub_Services &&
                                    <>
                                        {Select_Services ?
                                            <div className='d-flex  '>
                                                <button onClick={() => { setSelectedPDF(""); setSelect_Services("") }}
                                                    className="btn btn-sm btn-primary bi bi-chevron-left text-white " title='Back'>
                                                </button>
                                                <button onClick={() => { setSelectedPDF(""); setSelect_Services("") }}
                                                    className='btn btn-sm  d-flex rounded-pill text-start '
                                                >
                                                    {Select_Services}
                                                    {/* <div className="close-button ms-2 text-danger">&times;</div> */}
                                                </button>

                                            </div>
                                            :
                                            <button onClick={() => { setSelectedPDF(""); setSelect_Menu(""); }}
                                                className="btn btn-sm btn-primary  bi bi-chevron-left " title='Back'>
                                            </button>
                                        }
                                    </>
                                }
                                {Select_Services === "Industry Services" &&
                                    <>
                                        {Select_Sub_Services &&

                                            <div className=''>
                                                <button onClick={() => { setSelectedPDF(""); setSelect_Sub_Services(""); }}
                                                    className="btn btn-sm btn-primary bi bi-chevron-left ">
                                                </button>
                                                <button className='btn btn-sm border border-1 rounded-pill text-start'>{Select_Services}</button>
                                                <button className='btn btn-sm border border-1 rounded-pill text-start'>{Select_Sub_Services}</button>
                                            </div>

                                        }
                                    </>
                                }

                            </>

                        )}
                        {Select_Menu === "Type your query" &&
                            <button onClick={() => { setSelect_Menu(""); }}
                                className="btn btn-sm btn-primary bi bi-chevron-left ">
                            </button>
                        }
                    </div>
                    <div className=''>
                        <button onClick={() => setzoomed(!zoomed)} className={zoomed ? 'btn bi-arrows-angle-contract' : 'btn bi bi-arrows-angle-expand'}></button>
                    </div>
                </div>



                {llm_Mode ?
                    <div className='p-5'
                    >
                        <div className="text-center">
                            {Loader ? (
                                <img
                                    src={ThinkImage}
                                    alt="Thinking Icon"
                                    style={{ width: '300px', height: '300px' }}
                                />
                            ) : Speaking ? (
                                <img
                                    src={SpeakImage}
                                    alt="Speaking Icon"
                                    style={{ width: '300px', height: '300px' }}
                                />
                            ) : (
                                <img
                                    src={DOTMitraIcon}
                                    alt="User Icon"
                                    style={{ width: '300px', height: '300px' }}
                                />
                            )}
                        </div>
                        <div className='d-flex justify-content-around'>
                            <button className='btn bi bi-x-circle-fill text-danger fs-1' onClick={() => setLLM_MODE(false)}></button>
                            {Speaking ?
                                <button className='btn bi bi-stop-circle-fill text-danger fs-1' onClick={() => stopSpeak()}></button>
                                :
                                <button className='btn bi bi-mic text-danger fs-1' onClick={() => startListening()}></button>
                            }
                        </div>

                    </div>

                    :
                    <>

                        <div className="chatbox__container ">
                            {zoomed &&
                                <div className="chatbox__iframe">
                                    {selectedPDF ?
                                        <>
                                            {!GotopageNumber && <iframe src={`${iframesrc}#page=${pageNumber}`} width="100%" height="100%" title='show pdf'></iframe>}

                                        </>
                                        :
                                        <div className='text-center'>No PDF Selected</div>
                                    }
                                </div>
                            }
                            {/* <div className="LLMswitch form-check form-switch">
                                <label className="form-check-label" for="flexSwitchCheckDefault"> LLM</label>
                                <input className="form-check-input" type="checkbox" role="switch" />
                            </div> */}


                            <div className="chatbox__messages">
                                {!Select_Menu &&
                                    <>
                                        <div className='mt-4 text-center'>
                                            <h5 style={{ fontSize: "16px" }}>Hi There, <br /> DoT Mitra is here to help you</h5>
                                            <p style={{ color: "gray", fontSize: "12px" }}>Please select one of the options below or type your query</p>
                                        </div>

                                        <button onClick={(e) => { setSelect_Menu("Select PDF"); setSelectedPDF(""); }} className="button">
                                            <div>
                                                <span className="icon pdf"></span>
                                                <span>Select PDF</span>
                                            </div>
                                            <span className="arrow">&gt;</span>
                                        </button>
                                        <button onClick={(e) => { setSelect_Menu("Select a Service"); setSelectedPDF(""); }} className="button">
                                            <div>
                                                <span className="icon services"></span>
                                                <span>Select a Service</span>
                                            </div>
                                            <span className="arrow">&gt;</span>
                                        </button >
                                        <button onClick={(e) => { setSelect_Menu("Type your query"); setSelectedPDF("All") }} className="button">
                                            <div>
                                                <span className="icon query"></span>
                                                <span>Type your query</span>
                                            </div>
                                            <span className="arrow">&gt;</span>
                                        </button>
                                    </>
                                }

                                {Select_Menu === "Select PDF" &&
                                    <>
                                        {!selectedPDF &&
                                            (<div>
                                                <div className='py-2'>
                                                    <div className="">Choose a PDF Document</div>
                                                    <div className="text-muted ">
                                                        Select a PDF and enter your query to proceed.
                                                    </div>
                                                </div>
                                                <button onClick={(e) => { setSelectedPDFName("All PDF"); setSelectedPDF("All_PDF"); }}
                                                    className='btn btn-sm btn-gray-500 m-1 border border-1 d-flex truncate rounded-pill text-start'
                                                >
                                                    <i className="bi-file-earmark-pdf me-2 text-primary"></i>
                                                    All PDF
                                                </button>
                                                {pdfs.map((pdf) => (
                                                    <button onClick={(e) => { setSelectedPDFName(pdf.filename); setSelectedPDF(pdf.file); setsuggestedquestion([]); setsummery(''); }}
                                                        className='btn btn-sm btn-gray-500 m-1 border border-1 d-flex truncate rounded-pill text-start'
                                                        key={pdf.id} value={pdf.file}>
                                                        <i className="bi-file-earmark-pdf me-2 text-primary"></i>
                                                        {pdf.filename || pdf.file.split("/").pop()}
                                                    </button>
                                                ))}

                                            </div>)
                                        }
                                        {messages.map((msg, index) => (
                                            <div className='d-flex '>
                                                {msg.name === 'Sam' && (
                                                    <img
                                                        src={DOTMitraIcon}
                                                        alt="User Icon"
                                                        style={{ width: '40px', height: '40px', marginRight: '0px', marginTop: "10px", verticalAlign: 'middle' }}
                                                    />
                                                )}
                                                <div
                                                    key={index}
                                                    className={`messages__item mb-2 ${msg.name === 'Sam' ? 'messages__item--visitor' : 'messages__item--operator'}`}
                                                >
                                                    {msg.name === 'Sam' &&
                                                        <>
                                                            <button className='btn bi bi-volume-up' onClick={() => {
                                                                const cleaned = msg.message
                                                                    .replace(/[*\-_~`]+/g, "") // Remove markdown
                                                                    .replace(/Question:\s*\d+/gi, "") // Remove question number
                                                                    .replace(/Page:\s*\d+/gi, "") // Remove page number
                                                                    .replace(/Answering from https:\/\/eservices\.dot\.gov\.in\/faqs/gi, "") // Remove FAQ link
                                                                    .trim();
                                                                speak(cleaned); setspeakdata(msg.message);
                                                            }}></button>
                                                            {(Speaking && speakdata === msg.message) &&
                                                                <button className='btn bi bi-stop-circle-fill text-danger' onClick={() => stopSpeak()}></button>
                                                            }
                                                        </>

                                                    }
                                                    {/* <span dangerouslySetInnerHTML={{ __html: sanitizeMessage(msg.message) }} /> */}
                                                    <div className="chat-message">
                                                        {msg.message
                                                            ? renderMessageContent(msg.message, triggerGotoPage, msg.suggestion)
                                                            :
                                                            // <span>{msg.message}</span>
                                                            ""
                                                        }
                                                    </div>

                                                </div>
                                            </div>

                                        ))}

                                        {suggestedquestion.length >= 1 && <h6 className='text-muted mt-3'>Suggested Questions</h6>}

                                        {/* {Loader && <div className="messages__item messages__item--visitor">Okay, let's break down the information and craft a clear response to the question: "{inputText}"
                                            
                                            </div>} */}
                                        {Loader && <div className="loader"></div>}
                                        <sapn >
                                            {suggestedquestion.map((suggestion, index) => (
                                                <button
                                                    className="question-button"
                                                    onClick={() => handleSendsuggestion(suggestion)}
                                                    key={index}
                                                >
                                                    {suggestion}
                                                </button>
                                            ))}
                                        </sapn>

                                    </>
                                }
                                {Select_Menu === "Select a Service" &&
                                    <>
                                        {!Select_Sub_Services &&
                                            <>
                                                {!Select_Services &&

                                                    <>
                                                        <button onClick={() => { setSelectedPDF("All_eservies"); setSelect_Services("All_eservies") }}
                                                            className='btn btn-sm m-1 border border-1 d-flex truncate rounded-pill text-start'
                                                        >
                                                            All Services
                                                        </button>
                                                        <button onClick={() => { setSelectedPDF("AboutUs"); setSelect_Services("About Us"); }}
                                                            className='btn btn-sm m-1 border border-1 d-flex truncate rounded-pill text-start'
                                                        >
                                                            About Us
                                                        </button>
                                                        <button onClick={() => { setSelect_Services("Industry Services") }}
                                                            className='btn btn-sm m-1 border border-1 d-flex truncate rounded-pill text-start'
                                                        >
                                                            Industry Services
                                                        </button>

                                                        <button onClick={() => { setSelectedPDF("Standards"); setSelect_Services("Standards"); }}
                                                            className='btn btn-sm m-1 border border-1 d-flex truncate rounded-pill text-start'
                                                        >
                                                            Standards
                                                        </button>


                                                    </>
                                                }
                                            </>
                                        }



                                        {(Select_Services === "About Us" || Select_Services === "Standards" || Select_Services === "All_eservies") &&
                                            (
                                                <>
                                                    {messages.map((msg, index) => (
                                                        <div
                                                            key={index}
                                                            className={`messages__item mb-2 ${msg.name === 'Sam' ? 'messages__item--visitor' : 'messages__item--operator'}`}
                                                            dangerouslySetInnerHTML={{ __html: msg.message }}
                                                        />
                                                    ))}

                                                    {suggestedquestion.length >= 1 && <h2>Suggested Questions</h2>}
                                                    {Loader && <div class="loader"></div>}
                                                    <sapn className='questions'>
                                                        {suggestedquestion.map((suggestion, index) => (
                                                            <button
                                                                className="question-button"
                                                                onClick={() => handleSendsuggestion(suggestion)}
                                                                key={index}
                                                            >
                                                                {suggestion}
                                                            </button>
                                                        ))}
                                                    </sapn>
                                                </>
                                            )

                                        }
                                        {Select_Services === "Industry Services" &&
                                            <>
                                                {!Select_Sub_Services &&
                                                    <>
                                                        <button onClick={() => { setSelectedPDF("UnifiedLicense"); setSelect_Sub_Services("Unified License"); }}
                                                            className='btn btn-sm m-1 border border-1 d-flex truncate rounded-pill text-start'
                                                        >
                                                            Unified License (UL)
                                                        </button>
                                                        <button onClick={() => { setSelectedPDF("SACFA"); setSelect_Sub_Services("SACFA"); }}
                                                            className='btn btn-sm m-1 border border-1 d-flex truncate rounded-pill text-start'
                                                        >
                                                            SACFA
                                                        </button>
                                                        <button onClick={() => { setSelectedPDF("RightofWayRelated"); setSelect_Sub_Services("Right of Way Related"); }}
                                                            className='btn btn-sm m-1 border border-1 d-flex truncate rounded-pill text-start'
                                                        >
                                                            Right of Way Related
                                                        </button>
                                                    </>


                                                }

                                                {Select_Sub_Services === "Unified License" &&
                                                    <>
                                                        {messages.map((msg, index) => (
                                                            <div
                                                                key={index}
                                                                className={`messages__item mb-2 ${msg.name === 'Sam' ? 'messages__item--visitor' : 'messages__item--operator'}`}
                                                                dangerouslySetInnerHTML={{ __html: msg.message }}
                                                            />
                                                        ))}

                                                        {suggestedquestion.length >= 1 && <h2>Suggested Questions</h2>}
                                                        {Loader && <div class="loader"></div>}
                                                        <sapn className='questions'>

                                                            {suggestedquestion.map((suggestion, index) => (
                                                                <button
                                                                    className="question-button"
                                                                    onClick={() => handleSendsuggestion(suggestion)}
                                                                    key={index}
                                                                >
                                                                    {suggestion}
                                                                </button>
                                                            ))}
                                                        </sapn>

                                                    </>
                                                }
                                                {Select_Sub_Services === "SACFA" &&
                                                    <>
                                                        {messages.map((msg, index) => (
                                                            <div
                                                                key={index}
                                                                className={`messages__item  mb-2 ${msg.name === 'Sam' ? 'messages__item--visitor' : 'messages__item--operator'}`}
                                                                dangerouslySetInnerHTML={{ __html: msg.message }}
                                                            />
                                                        ))}

                                                        {suggestedquestion.length >= 1 && <h2>Suggested Questions</h2>}
                                                        {Loader && <div class="loader"></div>}
                                                        <sapn className='questions'>

                                                            {suggestedquestion.map((suggestion, index) => (
                                                                <button
                                                                    className="question-button"
                                                                    onClick={() => handleSendsuggestion(suggestion)}
                                                                    key={index}
                                                                >
                                                                    {suggestion}
                                                                </button>
                                                            ))}
                                                        </sapn>

                                                    </>
                                                }
                                                {Select_Sub_Services === "Right of Way Related" &&
                                                    <>
                                                        {messages.map((msg, index) => (
                                                            <div
                                                                key={index}
                                                                className={`messages__item  mb-2 ${msg.name === 'Sam' ? 'messages__item--visitor' : 'messages__item--operator'}`}
                                                                dangerouslySetInnerHTML={{ __html: msg.message }}
                                                            />
                                                        ))}

                                                        {suggestedquestion.length >= 1 && <h2>Suggested Questions</h2>}
                                                        {Loader && <div class="loader"></div>}
                                                        <sapn className='questions'>

                                                            {suggestedquestion.map((suggestion, index) => (
                                                                <button
                                                                    className="question-button"
                                                                    onClick={() => handleSendsuggestion(suggestion)}
                                                                    key={index}
                                                                >
                                                                    {suggestion}
                                                                </button>
                                                            ))}
                                                        </sapn>

                                                    </>
                                                }

                                            </>
                                        }



                                    </>
                                }
                                {Select_Menu === "Type your query" &&
                                    <>


                                        {messages.map((msg, index) => (
                                            <div
                                                key={index}
                                                className={`messages__item mb-2 ${msg.name === 'Sam' ? 'messages__item--visitor' : 'messages__item--operator'}`}
                                                dangerouslySetInnerHTML={{ __html: msg.message }}
                                            />
                                        ))}

                                        {suggestedquestion.length >= 1 && <h2>Suggested Questions</h2>}
                                        {Loader && <div class="loader"></div>}
                                        <sapn className='questions'>

                                            {suggestedquestion.map((suggestion, index) => (
                                                <button
                                                    className="question-button"
                                                    onClick={() => handleSendsuggestion(suggestion)}
                                                    key={index}
                                                >
                                                    {suggestion}
                                                </button>
                                            ))}
                                        </sapn>

                                    </>
                                }


                                {/* {isTyping && <div className="messages__item messages__item--visitor">DOT Mitra is typing...</div>} */}
                                <div ref={messagesEndRef} />
                            </div>

                        </div>
                        <div className="chatbox__footer">
                            <div class="input-container">
                                <input type="text"
                                    placeholder={"Ask question from DoT Mitra..."}
                                    value={inputText}
                                    onChange={(e) => setInputText(e.target.value)}
                                    onKeyUp={handleKeyUp}
                                    disabled={!Select_Menu || !selectedPDF}
                                    className={`input-field ${!Select_Menu || !selectedPDF ? "disabled" : ""}`}
                                />
                                {inputText ?
                                    <i onClick={() => handleSendMessage(inputText)} className="material-icons cursor-pointer me-2">&#xe163;</i>
                                    :
                                    <i className='cursor-pointer'

                                    >
                                        {isListening ?
                                            <button className="mic_btn me-2" onClick={() => stopListening()}

                                            >
                                                <div className="pulse-ring"></div>
                                                <i className="bi bi-mic fs-6 text-white"></i>
                                            </button>
                                            : <i className={`bi bi-mic-mute fs-6 text-primary  m-2 input-field ${!Select_Menu || !selectedPDF ? "disabled" : ""}`}
                                                // className="bi bi-mic-mute fs-6 text-primary  m-2"

                                                onClick={() => startListening()}
                                                style={{ backgroundColor: "#ffffff", borderRadius: "50%", padding: "8px 5px" }}
                                            ></i>}
                                    </i>
                                }



                            </div>

                            <i className="bi bi-soundwave text-primary ms-2 cursor-pointer fs-5" style={{ backgroundColor: "#ffffff", borderRadius: "50%", padding: "2px 7px" }}
                                onClick={() => { setLLM_MODE(true); setSelectedPDF("All"); speak("Hi There, D O T Mitra is here to help you"); }}
                            ></i>
                        </div>
                    </>
                }



            </div>


            {!isActive ?
                <div className="chatbox__button" >
                    <button onClick={() => { setIsActive(!isActive); setzoomed(false); }}>
                        {/* <img src={chatboxIcon} alt="Chatbox Icon" /> */}
                        <div className="chatbot-icon">
                            <div className="eyes">
                                <div className="eye"></div>
                                <div className="eye"></div>
                            </div>
                            <div className="mouth"></div>
                        </div>
                    </button>
                </div>
                :
                <div className="chatbox__button position-absolute bottom-0 end-0" >
                    <button onClick={() => { setIsActive(!isActive); setzoomed(false); }}>
                        {/* <img src={chatboxIcon} alt="Chatbox Icon" /> */}
                        <i className="bi-x-circle-fill fs-5 text-success"></i>
                    </button>
                </div>
            }

        </div>
    );
};

export default Chatbox;
